import React from 'react';
import BaechaGroupDone from "../containers/BaechaGroupDone/BaechaGroupDone";

const BaechaGroupDonePage: React.FC = () => {
	return (<BaechaGroupDone />);
};

export default BaechaGroupDonePage;
